import { render, staticRenderFns } from "./ExamDoRight.vue?vue&type=template&id=3e54f6f0&"
import script from "./ExamDoRight.vue?vue&type=script&lang=js&"
export * from "./ExamDoRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports